import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/layouts/auth.vue").then(m => m.default || m)),
  plataform: defineAsyncComponent(() => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/layouts/plataform.vue").then(m => m.default || m))
}